import AdditionalAreas from './additional-areas-container'

export default AdditionalAreas
